import { CountryCode, Messages } from '@efacity/common';
import { optionalPhoneValidator } from '@efacity/frontend-shared';
import { emptyAddress } from '@efacity/react-next-sc';
import * as yup from 'yup';

export interface CustomerFormValues {
  fullName: string;
  email: string;
  shouldSyncDataFromUser: boolean;
  phone?: string;
  phoneCountry?: string;
  address: {
    address: string;
    country: string;
    city: string;
    zip: string;
    state: string;
  };
}

export const initialCustomerFormValues: CustomerFormValues = {
  fullName: '',
  email: '',
  shouldSyncDataFromUser: true,
  phone: '',
  phoneCountry: CountryCode.USA,
  address: emptyAddress
};

export const editCustomerValidationSchema = yup.object().shape({
  fullName: yup.string().required(Messages.NameRequired),
  phone: optionalPhoneValidator('phone'),
  phoneCountry: yup.string().required()
});
